import { SampleTable } from "@/shared/components/ui";
import { useFetchOrdenTrabajos } from "@/shared/actions/erp";
import { useCheckPermissions, useTableColumnsPreagendamientoVentas } from "@/shared/hooks";
import { Button, Grid } from "@mui/material";
import { OpenInNew } from "@mui/icons-material";
import { useState } from "react";
import {  OrdenTrabajo } from "@/shared/interfaces";
import { PermissionsEnum } from "@/auth/interfaces";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";

type InfoOrdenTrabajoProps = {
  codigo: string
}
export default function InfoOrdenTrabajo({
  codigo
}: InfoOrdenTrabajoProps) {
  useCheckPermissions(PermissionsEnum.api_view_agendamiento);

  const {
    columnaOrdebTrabajoContrato

  } = useTableColumnsPreagendamientoVentas({});

  const [open, setOpen] = useState(false);
  const [enabled, setEnabled] = useState(false);

  const {
    isLoading,
    data: agendamientoResp,
  } = useFetchOrdenTrabajos({
    enabled: enabled,
    params: {
      page: 1,
      page_size: 1,
      codigo
    }
  });

  return (
    <>
      <Button
        color="primary"
        startIcon={<OpenInNew />}
        onClick={() => {
          setOpen(true)
          setEnabled(true)
        }}
      >
        VER
      </Button>

      {
        open && (
          <ScrollableDialogProps
            onCloseIcon={() => setOpen(false)}
            open={open}
            title="Orden Trabajo"
            minWidth="75%"
            contentNode={
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <SampleTable<OrdenTrabajo>
                    isLoading={isLoading}
                    data={agendamientoResp?.data.data || []}
                    columns={columnaOrdebTrabajoContrato}
                    enablePagination
                  />
                </Grid>
              </Grid>
            }
          />
        )
      }
    </>
  );



}